import { EntityModel } from '@/interfaces'
import {
  ALL_WEBHOOK_LOGS_QUERY,
  CREATE_WEBHOOK_LOG_MUTATION,
  DELETE_WEBHOOK_LOG_MUTATION,
  FORCE_DELETE_WEBHOOK_LOG_MUTATION,
  SINGLE_WEBHOOK_LOG_QUERY,
  UPDATE_WEBHOOK_LOG_MUTATION,
} from './graphql'
import webhookLogEntity from '@/entities/webhookLog/entity'

const webhookLogModel: EntityModel = {
  name: 'webhookLog',
  namePlural: 'webhookLogs',
  uniqueName: 'webhookLog',
  uniqueNamePlural: 'webhookLogs',
  path: 'webhooks/webhook_log',
  baseUrl: '/webhooks/webhook_logs',
  translationPrefix: 'entities:webhookLog.',
  getDisplayName: (values: any) => {
    return 'WEBHOOK LOG'
  },
  gql: {
    getAll: ALL_WEBHOOK_LOGS_QUERY,
    getSingle: SINGLE_WEBHOOK_LOG_QUERY,
    create: CREATE_WEBHOOK_LOG_MUTATION,
    update: UPDATE_WEBHOOK_LOG_MUTATION,
    delete: DELETE_WEBHOOK_LOG_MUTATION,
    forceDelete: FORCE_DELETE_WEBHOOK_LOG_MUTATION,
  },
  attributes: {
    type: {
      name: 'type',
      label: 'entities:webhookLog.attributes.type.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    status: {
      name: 'status',
      label: 'entities:webhookLog.attributes.status.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    url: {
      name: 'url',
      label: 'entities:webhookLog.attributes.url.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    payload: {
      name: 'payload',
      label: 'entities:webhookLog.attributes.payload.label',
      type: 'value',
      dataType: '{ [x: string]: any }',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    statusCode: {
      name: 'statusCode',
      label: 'entities:webhookLog.attributes.statusCode.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    response: {
      name: 'response',
      label: 'entities:webhookLog.attributes.response.label',
      type: 'value',
      dataType: '{ [x: string]: any }',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    executionTime: {
      name: 'executionTime',
      label: 'entities:webhookLog.attributes.executionTime.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    retryCount: {
      name: 'retryCount',
      label: 'entities:webhookLog.attributes.retryCount.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    original: {
      name: 'original',
      label: 'entities:webhookLog.attributes.original.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return webhookLogEntity
      },
      defaultInput: true,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default webhookLogModel
